import { useEffect, useState } from "react";

export function useIsPlayerReady(
  playerRef: React.RefObject<HTMLElement | null>,
): boolean {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkReady = () => {
      const el = playerRef.current;

      if (!el) return false;

      const playerElement = el.querySelector(".bwp");
      if (!playerElement) return false;

      return getComputedStyle(playerElement).display !== "none";
    };

    const interval = setInterval(() => {
      if (checkReady()) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [playerRef]);

  return isReady;
}
